// src/utils/conversations.js
import axios from 'axios';

export const fetchConversations = async (channel) => {
  try {
    const response = await axios.get(`/api/conversations?channel=${channel}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching conversations:', error);
    throw error;
  }
};
